var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPanelStatWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 554,
    height: 71,
    viewBox: "0 0 554 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 39.7085C1 39.7085 19.1496 38.325 36.6562 27.0078C54.1629 15.6907 69.7072 6.76333 69.7072 6.76333C69.7072 6.76333 93.4215 -4.76333 112.512 6.76333C131.602 18.29 169.798 51.9337 169.798 51.9337C169.798 51.9337 190.387 61.2573 210.997 45.9038C231.608 30.5502 257.588 7.74082 257.588 7.74082C257.588 7.74082 275.488 -4.97339 298.108 9.12377C320.727 23.2209 337.337 45.9038 337.337 45.9038C337.337 45.9038 362.23 75.0886 395.907 54.1467C429.585 33.2048 429.867 31.9479 429.867 31.9479C429.867 31.9479 460.05 13.8102 497.064 34.3975C534.078 54.9847 553 55.2191 553 55.2191V71H1V39.7085Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 39.7736C1 39.7736 19.1496 38.3878 36.6562 27.0516C54.1629 15.7154 69.7072 6.77303 69.7072 6.77303C69.7072 6.77303 93.4215 -4.77303 112.512 6.77303C131.602 18.3191 169.798 52.0194 169.798 52.0194C169.798 52.0194 190.387 61.3588 210.997 45.9794C231.608 30.6 257.588 7.75217 257.588 7.75217C257.588 7.75217 275.488 -4.98345 298.108 9.13745C320.727 23.2583 337.337 45.9794 337.337 45.9794C337.337 45.9794 362.23 75.2133 395.907 54.2362C429.585 33.259 429.867 32 429.867 32C429.867 32 460.05 13.8318 497.064 34.4537C534.078 55.0756 553 55.3104 553 55.3104",
    stroke: "#FF9920",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 1,
    y1: 1,
    x2: 1,
    y2: 71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9920"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE",
    stopOpacity: 0.01
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPanelStatWarning);
export default __webpack_public_path__ + "static/media/panel-stat-warning.eb32725e883397bf07ce272aabbaf10c.svg";
export { ForwardRef as ReactComponent };